module.exports = __webpack_public_path__ + "static/img/kangtiya_icon.fe70390.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img_icon/kangtiya_icon.png
// module id = 3+Yn
// module chunks = 1